'use strict';exports.__esModule = true;exports.setPinAsReviewed = undefined;var _reduxAct = require('redux-act');

var setPinAsReviewed = (0, _reduxAct.createAction)('/SET_PIN_AS_REVIEWED');

var initialState = {
  reviewedIds: [] };


var handleSetPinAsReviewed = function handleSetPinAsReviewed(state, id) {
  var reviewedIds = [].concat(state.reviewedIds);

  if (reviewedIds.indexOf(id) === -1) {
    reviewedIds.push(id);
  }

  return Object.assign({},
  state, {
    reviewedIds: reviewedIds });

};

var reviewedPins = (0, _reduxAct.createReducer)(function (on) {
  on(setPinAsReviewed, handleSetPinAsReviewed);
}, initialState);exports.


setPinAsReviewed = setPinAsReviewed;exports.default =


reviewedPins;


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/reviewedPins.js
// module id = 234
// module chunks = 0